let zhObj = {};
[
    '广园汇汽配港登录',
    '登录名/手机号/电子邮箱',
    '密码',
    '记住账号',
    '找回密码',
    '登录',
    '没有账号,立即注册',
    '快速注册',
    '手机号',
    '验证码',
    '短信验证码',
    '发送验证码',
    '联系人',
    '公司名称',
    '我已阅读并同意',
    '《用户协议》',
    '《隐私政策》',
    ',并授权使用该账',
    '号信息（如昵称、头像、收货地址）进行管理。',
    '注册',
    '已有账号,立即登录',
    '再次发送',
    '秒',
    '新密码',
    '修改密码',
    '首页',
    '展会概况',
    '查看详情',
    '活动介绍',
    '展会新闻',
    '更多',
    '资讯',
    '视频',
    '热门资讯',
    '热门视频',
    '视频头条',
    '所在地区',
    '企业类型',
    '车系',
    '品牌',
    '企业名称',
    '配件分类一',
    '配件分类二',
    '配件品牌',
    '商品名称',
    '查询',
    '重置',
    '商品图片',
    '商品名称',
    '商品编码',
    '供应商',
    '指导价',
    '操作',
    '暂无数据',
    '指导价',
    '最小包装数量',
    '品质',
    '数量',
    '立即询价',
    '联系客服',
    '发布商机',
    '规格参数',
    '商品类别',
    '适用车型',
    '是否钉箱',
    '每车适用数量',
    '重量',
    '尺寸',
    '汽配嘉年华',
    '汽配港头条',
    '企业库',
    '产品库',
    '撮合商机',
    '关于我们',
    '联系人姓名',
    '称谓',
    '先生',
    '女士',
    '职务',
    '公司类型',
    '手机',
    'E-mail',
    '电话',
    '网址',
    '感兴趣的展区',
    '工厂零部件专区。',
    '车型品牌配件专区。',
    '新能源配件展区。',
    '汽车后市场数字化专区。',
    '提交申请',
    '参加人数',
    '活动时间',
    '人',
    '观众登记',
    '展商登记',
    '注册类型',
    '联系电话',
    '姓名',
    '产品品类',
    '工厂',
    '汽配品牌商',
    '维修厂/连锁',
    '其他',
    '欢迎来到广园汇汽配港!',
    '退出登录',
    '免费注册',
    '新闻',
    '扫一扫关注官方公众号和小程序',
    '实力工厂',
    '查看更多',
    '优秀品牌',
    '优秀产品',
    '搜索',
    '请输入商品名称',
    '请输入公司名称',
    '商品',
    '公司',
    '购物车',
    '去购物车结算',
    '共',
    '件商品',
    '注册资金',
    '成立时间',
    '主营产品',
    '配套客户',
    '企业信息',
    '主营品类',
    '主营车型',
    '认证专利',
    '库存',
    '立即抢购',
    '暂无商品',
    '广',
    '汇',
    '保',
    '销',
    '汽配展贸',
    '实力工厂',
    '品质保证',
    '汽配出海',
    '账号管理',
    '账户注册',
    '信息维护',
    '安全隐私',
    '采购指南',
    '平台简介',
    '采购流程',
    '物流配送',
    '配送方式',
    '售后服务',
    '售后政策',
    '退货流程及规则',
    '联系我们',
    '关于广园汇',
    '联系方式',
    '东莞广园汇供应链有限公司',
    '粤ICP备2024268269号-1',
    '我的',
    '帮助中心',
    '发布RFQ',
    '该功能尚未开通，敬请期待!',
    '底盘系列',
    '汽车养护系列',
    '发动机',
    '发动机系列',
    '车身系列',
    '展商入口',
    '观众入口',
    '商机管理',
    '我的商机',
    '产品管理',
    '我的产品',
    '参展管理',
    '我的展位',
    '我的收藏',
    '关注工厂',
    '关注产品',
    '个人中心',
    '企业信息',
    '未知',
    '编码/名称',
    '类别',
    '上传',
    '未审核',
    '审核通过',
    '审核不通过',
    '未知状态',
    '状态',
    '参考价格',
    '下架',
    '上架',
    '删除',
    '库存模板',
    '参展活动',
    '我要参展',
    '届次',
    '活动名称',
    '活动时间',
    '参展状态',
    '未参展',
    '身份',
    '展位',
    '广园汇',
    '汽配港',
    '全部配件',
    '可询价',
    '可采购',
    '商品信息',
    '单价',
    '小计',
    '操作',
    '随便逛逛',
    '是否退出登录?',
    '确定',
    '取消',
    '提示',
    '退出登录成功!',
    // 购物车
    '全部配件',
    '可询价',
    '可采购',
    '商品信息',
    '单价',
    '小计',
    '操作',
    '随便逛逛',
    // 商机
    '供应',
    '需求',
    '合作',
    '招商',
    '其他',
    '热门产品',
    '项目分类',
    '搜项目',
    '您还可以选择',
    '最新采购项目',
    '热门采购项目',
    '近期采购',
    // 例如 {{1小时}}前发布
    '前发布',
    '优质项目推荐',
    '近期采购',
    // 发布商机
    '商机标题',
    '请简短描述您的商机主题',
    '商机类型',
    '其他商机类型：',
    '请简短描述您的商机类型',
    '产品分类',
    '所有',
    '商机产品',
    '您的商机主要针对的产品',
    '发布人',
    '请输入您的名字',
    '发布人手机号',
    '请输入您的手机号',
    '发布人公司',
    '附加材料',
    '选取文件',
    '支持上传图片或文件',
    '发布',
    '请输入内容',
    '请输入商机标题',
    '请输入发布人',
    '请输入手机号码',
    '请输入有效的手机号码',
    '请输入公司名称',
    '请输入公司名称',
    '新增商机成功',
    '新增商机失败',
    '请检查输入项！',
    '个人信息认证',
    '微信认证',
    '企业邮箱认证',
    '实名认证',
    '手机号认证',
    '企业信息认证',
    '营业执照认证',
    '品牌商标认证',
    '企业门头',
    '实地认证',
    '高级认证',
    'IS09001认证',
    'IATF16949认证',
    '配套资质认证',
    '供应商认证',
    '服务能力认证',
    '汽配港参展企业',
    '产品目录认证',
    '汽配港入仓认证',
    '进出口资质认证',
    '平台能力',
    '活跃企业',
    '及时响应',
    '官方品牌代理授权',
    '现货仓储认证',
    '外贸能力',
    '外贸经营企业',
    '平台服务(经营eBay、亚马逊等)',
    '海外仓',
    '出口资质认证',
    '企业指数',
    '更新',
    '个人',
    '企业',
    '服务',
    '认证',
    '数字化',
    '超过全国',
    '%同行企业',
    '共 {total_count} 件商品，已选择 {choose_count} 件，商品合计',
    '批量删除',
    '下单结算',
    '上传失败',
    '个人',
    '企业',
    '服务',
    '认证',
    '数字化',
    '外贸',
    '请输入您的商机主要针对的产品',
    '注册成功',
    '加入购物车',
    '加入购物车成功!',
    '外资独资',
    '足迹',
    '没有更多了',
    '删除成功',
    '确认删除吗?',
    '确认',
    '上架成功',
    '下架成功',
    '空'

].map(item => zhObj[item] = item)

export default zhObj